module.exports = __webpack_public_path__ + "static/media/fme_form_basic_logo.eabdd820.png";